import { render, staticRenderFns } from "./FiscalMandateForm.vue?vue&type=template&id=51144c33&scoped=true&"
import script from "./FiscalMandateForm.vue?vue&type=script&lang=ts&"
export * from "./FiscalMandateForm.vue?vue&type=script&lang=ts&"
import style0 from "./FiscalMandateForm.vue?vue&type=style&index=0&id=51144c33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51144c33",
  null
  
)

export default component.exports